// src/components/CariHesaplar.js

import React, { useState, useEffect, useMemo } from 'react';
import { db } from '../firebase';
// YENİ: 'workOrders' sorgusu (onSnapshot) kaldırıldı, sadece 'customers' kaldı.
import { collection, query, onSnapshot } from 'firebase/firestore';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, TextField, InputAdornment, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PageviewIcon from '@mui/icons-material/Pageview';

const CariHesaplar = () => {
    const [customers, setCustomers] = useState([]);
    // const [workOrders, setWorkOrders] = useState([]); // KALDIRILDI
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        // Sadece 'customers' koleksiyonunu çek
        const unsubCustomers = onSnapshot(query(collection(db, "customers")), (snapshot) => {
            setCustomers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false); // Yükleme burada bitiriliyor
        });
        
        // 'workOrders' koleksiyonunu çeken 'useEffect' kaldırıldı.
        
        return () => { unsubCustomers(); };
    }, []);

    // KALDIRILDI: 'customerFinancials' useMemo bloğu (hatalı hesaplamanın kaynağı) kaldırıldı.
    // Artık veriyi doğrudan 'customers' state'inden filtreleyeceğiz.

    // GÜNCELLENDİ: Filtreleme artık 'useMemo' olmadan, doğrudan 'customers' üzerinden yapılıyor
    const filteredData = customers.filter(customer =>
        customer.adSoyad.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) { return <CircularProgress sx={{ display: 'block', margin: 'auto', mt: 4 }} />; }

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h4" component="h1">Cari Hesaplar</Typography>
                <TextField size="small" variant="outlined" placeholder="Müşteri Ara..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} InputProps={{ startAdornment: ( <InputAdornment position="start"><SearchIcon /></InputAdornment> ) }}/>
            </Box>
            <Paper>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Müşteri Adı</TableCell>
                                {/* <TableCell align="center">İş Emri Sayısı</TableCell> // KALDIRILDI */}
                                <TableCell align="right">Toplam Ciro</TableCell>
                                <TableCell align="right">Toplam Tahsilat</TableCell>
                                <TableCell align="right">Güncel Bakiye</TableCell>
                                <TableCell align="center">İşlemler</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/* GÜNCELLENDİ: 'filteredData' (müşteri listesi) kullanılıyor */}
                            {filteredData.map(customer => (
                                <TableRow hover key={customer.id} sx={{cursor: 'pointer'}} onClick={() => navigate(`/cari-hesaplar/${customer.id}`)}>
                                    <TableCell sx={{fontWeight: 'bold'}}>{customer.adSoyad}</TableCell>
                                    
                                    {/* GÜNCELLENDİ: Veri kaynağı (toplamSatis, toplamOdeme, toplamBakiye) MusteriDetay.js ile eşitlendi */}
                                    <TableCell align="right">{(customer.toplamSatis || 0).toLocaleString('tr-TR', {style:'currency', currency:'TRY'})}</TableCell>
                                    <TableCell align="right" sx={{color: 'success.main'}}>{(customer.toplamOdeme || 0).toLocaleString('tr-TR', {style:'currency', currency:'TRY'})}</TableCell>
                                    <TableCell align="right" sx={{fontWeight: 'bold', color: customer.toplamBakiye > 0 ? 'error.main' : 'inherit'}}>
                                        {(customer.toplamBakiye || 0).toLocaleString('tr-TR', {style:'currency', currency:'TRY'})}
                                    </TableCell>
                                    
                                    <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        component={RouterLink}
                                        to={`/cari-hesaplar/${customer.id}`}
                                        startIcon={<PageviewIcon />}
                                      >
                                        Ekstre
                                      </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default CariHesaplar;